/**
 * functionRoleFilter.js
 *
 * Defines available function role descriptions for use in filter dropdowns.
 * Used to filter data by the user's decision-making role in the organization.
 */

export default [
  'I make strategic decisions that directly influence and drive the direction of the business',
  'I make management decisions (operational/functional/administrative) that contribute to the achievement of business targets',
  'I make technical decisions that affect the daily operational activities of the business',
];
